export const RENEWAL_NOTICE_DISMISSED_KEY = 'package-renewal-notice-dismissed';

function browserStorage() {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

// The saved value identifies the exact package and warning level.  A later,
// more urgent warning or a renewed package must be shown again.
export function isRenewalNoticeDismissed(noticeKey, storage = browserStorage()) {
  try {
    return Boolean(noticeKey) && Boolean(storage) &&
      storage.getItem(RENEWAL_NOTICE_DISMISSED_KEY) === noticeKey;
  } catch (error) {
    return false;
  }
}

export function dismissRenewalNotice(noticeKey, storage = browserStorage()) {
  try {
    if (noticeKey && storage) {
      storage.setItem(RENEWAL_NOTICE_DISMISSED_KEY, noticeKey);
    }
  } catch (error) {
    // Storage may be blocked. The notice is still closed for this page view.
  }
}
